/*
 * CART MANAGER
 */

/* notifications */

function notifyAddToCart(style, title, price, image) {

  Panda.Minipopup.open( {
    title: title,
    detail: ''
  });

  // $.notify({
  //     title: title,
  //     price: price,
  //     image: image
  // }, {
  //     style: 'rgb-notification',
  //     className: style,
  //     autoHide: true,
  //     autoHideDelay: 10000,
  //     clickToHide: true,
  //     globalPosition: 'b r',
  //     showAnimation: 'slideDown',
  //     showDuration: 400,
  //     hideAnimation: 'slideUp',
  //     hideDuration: 200
  // });
}

/* END notifications */

/**
 * aggiunge una quantità a un carrello
 */
function addToCart(article, quantity, catalog, type, notifyTitle, notifyContent, isPromo) {
  // console.log('addToCart');

  $.get( url__ecommerce_cart_add_to_cart, {
    article: article,
    quantity: quantity,
    catalog: catalog,
    type: type,
    time: Date.now(),
    isPromo: isPromo
  } , function( data ) {

    try {
      data = JSON.parse(data);
    } catch (e) {
      location.reload();
    }

    if(!data.error) {

      countItemsInCart();

      tagManager_addToCart([{
        'name': data.result.article.name,
        'id': data.result.article.code,
        'price': data.result.price,
        'brand': '',
        'category': (ga4category ? ga4category : null),
        'quantity': data.result.quantity
      }]);

      notifyAddToCart("white", data.result.article.code+' - '+data.result.article.title, data.result.quantity+' x '+data.result.price.formatMoney(5, ',', '.') + " €", "<img src='"+data.result.article.imageFilename+"'>");

      // $("form[data-article='"+article+"']").find("input.quantity").val("");
    } else {
      if (data.error_status == 'DISCOUNT_RANGE_NOT_MATCHED' || data.error_status == 'PROMO_QUANTITY_INVALID') {
        notifyAvailability("#add-to-cart-"+article, "white", data.error_title, data.error_description, article);
      }
    }
  });
}

/**
 * rimuove una riga del carrello
 */
function removeFromCart(article, catalog, type) {

  $.get( url__ecommerce_cart_remove_from_cart, {
    article: article,
    catalog: catalog,
    type: type,
    time: Date.now()
  } , function( data ) {

    try {
      data = JSON.parse(data);
    } catch (e) {
      location.reload();
    }

    if(!data.error) {

      countItemsInCart();

      $("tr.cart-row[data-article='"+article+"'][data-catalog='"+catalog+"'][data-type='"+type+"']").remove();

      setTimeout(function () {
//console.log($("tr.cart-row").length);
        if($("tr.cart-row").length == 0) {
          $("#cart-rows-table-wrapper").addClass("d-none");
          $("#no-products-in-cart-message").removeClass("d-none");
        } else {

          $(".js-cart-total").html(data.result.cart.total_formatted + " €");
        }
      }, 500);
    }
  });
}

/**
 * aggiorna una quantità nella riga di un carrello
 */
function updateCartRow(article, quantity, catalog, type) {
  console.log('updateCartRow');

  var row = $("tr.cart-row[data-article='"+article+"'][data-catalog='"+catalog+"'][data-type='"+type+"']").find('.js-cart-cartRow-quantity');

  if(quantity == 0) {
    // removeFromCart(article, catalog, type);
  } else {

    $.get( url__ecommerce_cart_add_to_cart, {
      article: article,
      quantity: quantity,
      catalog: catalog,
      type: type,
      overwriteQuantity: true,
      time: Date.now()
    } , function( data ) {

      try {
        data = JSON.parse(data);
      } catch (e) {
        location.reload();
      }

      if(!data.error) {

        countItemsInCart();

        $("tr.cart-row[data-article='"+article+"'][data-catalog='"+catalog+"'][data-type='"+type+"']")
          .removeClass("arriving")
          .removeClass("unavaiable")
          .addClass(data.result.article_status)
        // .removeClass("to-update")
        ;

        $("tr.cart-row[data-article='"+article+"'][data-catalog='"+catalog+"'][data-type='"+type+"']").find(".js-cart-cartRow-total").html(data.result.row.total_formatted + " €");
        // $(".cart-total").html(data.result.cart.total.formatMoney(5, ',', '.') + " €");
        $(".js-cart-total").html(data.result.cart.total_formatted + " €");
        // $("tr.cart-row[data-article='"+article+"'][data-catalog='"+catalog+"'][data-type='"+type+"']").find(".price-wrapper").html(data.result.price.formatMoney(5, ',', '.') + " €");
        // $("tr.cart-row[data-article='"+article+"'][data-catalog='"+catalog+"'][data-type='"+type+"']").find(".total").removeClass("hidden");
        // $("tr.cart-row[data-article='"+article+"'][data-catalog='"+catalog+"'][data-type='"+type+"']").find(".update-link").addClass("hidden");
// console.log(quantity);
        $("tr.cart-row[data-article='"+article+"'][data-catalog='"+catalog+"'][data-type='"+type+"']").find(".js-cart-cartRow-quantity").attr('data-quantity', quantity);


        setTimeout(function () {
          row.parent().removeClass('Bgc(froly)');
        }, 1000);
      } else {

        row.parent().addClass('Bgc(froly)');

        if (data.error_status == 'DISCOUNT_RANGE_NOT_MATCHED' || data.error_status == 'PROMO_QUANTITY_INVALID') {
          notifyAvailability("#add-to-cart-"+article, "white", data.error_title, data.error_description, article);
          if (quantity < data.constraints.min) {
            row.val(data.constraints.min);
            row.trigger('change');
          } else {
            if (data.constraints.multiple) {
              row.val(Math.ceil(quantity/data.constraints.min)*data.constraints.multiple);
              row.trigger('change');
            } else {
              row.val(data.constraints.min);
              row.trigger('change');
            }
          }

          setTimeout(function () {
            row.parent().removeClass('Bgc(froly)');
          }, 1000);
        }
      }
    });
  }
}

/**
 * conta i prodotti nel carrello (prodotto x quantità)
 */
function countItemsInCart(){

  if (url__ecommerce_cart_count_items) {
    $.get( url__ecommerce_cart_count_items, {
      time: Date.now()
    }, function( count ) {

      if (count) {
        $(".js-cart-items-counter").removeClass('D(n)!');
        $(".js-cart-items-counter").text(count);
      }
    });
  }
}

/**
 * nasconde un popover sulla disponibilità aperto
 */
function dismissAvailibilityNotificationPopover(id){

  $("button#add-to-cart-"+id).popover("hide");
}


/* **************************************************
 * Catalog
 */

/**
 * AddToCart Handler
 */
$("form.js-form-addToCart").submit(function (event) {
  event.preventDefault();

  // console.log('submit');

  var quantity = parseFloat(($(this).find("input[name='quantity']").val() < 1 ? 1 : $(this).find("input[name='quantity']").val()));
  var availability = parseFloat($(this).attr("data-availability"));
  var availabilityIncoming = parseFloat($(this).attr("data-availability-incoming"));
  var availabilityTotal = parseFloat($(this).attr("data-availability-total"));
  var minQtyToSell = parseFloat($(this).attr("data-min-qty-to-sell"));
  var minQtyCollo = parseFloat($(this).attr("data-min-qty-collo"));
  var pcsPerPkg = parseFloat($(this).attr("data-pcs-per-pkg"));
  var isPromo = parseInt($(this).attr("data-promo"));
  var isSubUser = parseInt($(this).attr("data-subuser"));

  var notify = false;
  var block = false;

  //console.log('   isPromo: '+isPromo, '   quantity: '+quantity, '   pcsPerPkg: '+pcsPerPkg, '   availability: '+availability, '   rest: '+(quantity%pcsPerPkg));

  var content = $(this).attr("data-notify-content");

  if (isSubUser) {

    if (quantity > parseInt(availabilityTotal)) {
      notify = true;
      content = $(this).attr("data-notify-subuser-total");
      block = true;
    } else if (quantity > availability) {
      notify = true;
    }

  } else if (isPromo) {

    // // se non è un multiplo della quantità conf allora avvio i controlli
    // if ((quantity%pcsPerPkg) != 0 && quantity != availability) {
    //     notify = true;
    //     block = true;
    // }

    // se non è un multiplo della quantità min vend allora avvio i controlli
    // if ((quantity%minQtyToSell) != 0 && quantity != availability) {
    //     notify = true;
    //     block = true;
    // }

    // } else if(quantity > availability) {
    //     notify = true;
  }

  if (notify) {
    notifyAvailability("#add-to-cart-"+$(this).attr("data-article"), "white", $(this).attr("data-notify-title"), content, $(this).attr("data-article"));
  }

  if (
    !block
  ) {
    addToCart(
      $(this).attr("data-article"),
      $(this).find("input[name='quantity']").val(),
      $(this).attr("data-catalog"),
      $(this).attr("data-type"),
      null,
      null,
      isPromo
    );
  }

});

/* **************************************************
 * Cart
 */

function addToCart__editQuantity(element) {
  var target = $(element).attr('data-target');
  var direction = $(element).attr('data-direction');
  var unit = parseInt($(element).attr('data-unit'));
  var quantity = parseInt($('#'+target).val() ? $('#'+target).val() : 0);
  var min = parseInt($('#'+target).attr('min') ? $('#'+target).attr('min') : 0);

  console.log('plusminus', {
    'target': target,
    'direction': direction,
    'unit': unit,
    'quantity': quantity,
    'min': min
  });

  if (direction == "1") {
    // add

    if ((quantity + unit) % unit == 0) {
      quantity = quantity + unit;
    } else {
      quantity = Math.floor((quantity + unit)/unit) * unit;
      if (quantity < min) {
        quantity = quantity + unit;
      }
    }
  } else {
    // sub
    quantity = quantity - unit;
    if (quantity < min) {
      quantity = min;
    }
  }

  console.log('new quantity: '+quantity);

  $('#'+target).val(quantity);

  setTimeout(function () {
    $('#'+target).trigger('change');
  }, 100);
}

/* **************************************************
 * On page loaded
 */
$(function () {
  $("form.js-form-addToCart").find("button").removeClass("disabled");

  if ($('.js-buttonPlusMinus').length) {

    $('.js-buttonPlusMinus').on('click', function () {
      addToCart__editQuantity(this);
    });

    var addToCart__timeOut = 0;

    $('.js-buttonPlusMinus').on('mousedown touchstart', function(e) {
      var element = this;
      addToCart__timeOut = setInterval(function(){
        addToCart__editQuantity(element);
      }, 500);
    }).bind('mouseup mouseleave touchend', function() {
      clearInterval(addToCart__timeOut);
    });
  }

  countItemsInCart();
});
